<script setup>
import {defineProps} from 'vue'

const props = defineProps({
  lgBorderRadius: {
    type: Boolean,
    required: false,
  },
  cardBodyClass: {
    type: [String, Object, Array],
    required: false,
    default: '',
  },
})
</script>

<template>
  <div :class="['card border-0', props.lgBorderRadius ? 'border-radius-lg' : '']">
    <div class="card-body" :class="cardBodyClass">
      <slot />
    </div>
  </div>
</template>
